import axiosInstance from "api/axios";
import {
  BulkStockMovementRequest,
  StockMovementAttributes,
  StockMovementStats,
} from "types/stockMovement.type";

export const stockMovementService = {
  getAll: async (
    page = 1,
    limit = 10,
    filters: Record<string, any> = {}
  ): Promise<{ data: StockMovementAttributes[]; total: number }> => {
    const response = await axiosInstance.get("/stock-movement/", {
      params: { page, limit, ...filters },
    });
    return response.data;
  },

  createBulk: async (
    data: BulkStockMovementRequest
  ): Promise<{ success: boolean; message: string }> => {
    const response = await axiosInstance.post("/stock-movement/bulk", data);
    return response.data;
  },

  getStats: async (): Promise<StockMovementStats> => {
    const response = await axiosInstance.get("/stock-movement/stats");
    return response.data;
  },
};
